<!--
  En escritorio esto es la tarjeta de compra; por debajo de 1200px se
  convierte en la barra fija de abajo, con el precio al lado de la acción.
  Si el evento es solo informativo no hay acción ninguna, así que se queda
  como tarjeta dentro del flujo.
-->
<div class="float-container d-grid" [class.has-actions]="hasActions">
  <p class="price-text"
    *ngIf="displayFromPrice > 0 && !event?.informative && !event?.external">Desde<span
      class="price">{{
      displayFromPrice | number: '1.0-2' }}€</span></p>
  <p class="price-text"
    *ngIf="displayFromPrice == 0 && !event.image_url?.includes('http') && !event?.informative && !event?.external"><span
      class="price">GRATUITO</span></p>
  <p class="price-text"
    *ngIf="(displayFromPrice <= 0 && event.image_url?.includes('http')) || event?.informative"><span
      class="price">+INFO</span></p>
  <!-- El título ya está en el encabezado de la ficha, a un dedo de aquí -->
  <div class="info-float-event">
    <div *ngIf="!repeat" class="d-flex"><span><i
          class="fa-light icon-float fa-calendar"></i></span>
      <div class="d-flex flex-wrap">

        <p class="m-0"
          *ngIf="((event.next_date || event.start_date) | date: 'yyyyMMdd':'+0000') == (today | date: 'yyyyMMdd':'+0000'); else notToday">
          Hoy
        </p>

        <ng-template #notToday>
          <p class="m-0">{{(event.next_date || event.start_date) | date: 'EEE, dd \'de\' MMMM':'+0000'}}</p>
        </ng-template>

        <span style="margin: 0px 2px;"
          *ngIf="event.end_date && (event.end_date | date: 'yyyyMMdd':'+0000') != ((event.next_date || event.start_date) | date: 'yyyyMMdd':'+0000')">-</span>

        <p class="m-0"
          *ngIf="event.end_date && (event.end_date | date: 'yyyyMMdd':'+0000') != ((event.next_date || event.start_date) | date: 'yyyyMMdd':'+0000')">
          {{ event.end_date | date: 'EEE, dd \'de\' MMMM':'+0000' }}</p>
      </div>
    </div>
    <div class="d-flex" *ngIf="optionsHour.length > 0">
      <span><i class="fa-light icon-float fa-clock fa-md"></i></span>

      <ng-container *ngIf="sameHoursForAllDates; else manyHoursTemplate">
        <div class="d-flex columns-hours flex-wrap"
          *ngIf="optionsHour.length <= 3; else manyHoursTemplate">
          <div class="d-flex columns-hours"
            *ngFor="let item of optionsHour; let i = index">
            <p class="m-0">
              {{ item.start_date | date:'HH:mm':'+0000' }}
            </p>
            <mat-divider [vertical]="true"
              *ngIf="i != optionsHour.length-1"></mat-divider>
          </div>
        </div>
      </ng-container>

      <ng-template #manyHoursTemplate>
        <div class="d-flex columns-hours flex-wrap">
          <p class="m-0">Varias horas disponibles</p>
        </div>
      </ng-template>
    </div>
    <!-- <div class="d-flex" *ngIf="event.extraLink">
      <span><i class="fa-light icon-float fa-link fa-md"></i></span>
      <a href="{{event?.extraLink}}" class="external-link" target="_blank">{{event?.extraLink}}</a>
    </div> -->
    <div class="d-flex">
      <span><i class="fa-light icon-float fa-location-dot"></i></span>
      <div>
        <p class="m-0">{{event?.address || event?.space?.address}}</p>
        <a class="link-map m-0" *ngIf="!viewTotem"
          (click)="goToScrollPage('map')">Cómo llegar</a>
      </div>
    </div>
  </div>
  <div class="buy-actions" *ngIf="!event?.informative && !viewTotem">
    <div *ngIf="event.sold_out; else divCompleteTemplate">
      <div class="container-btns-select">
        <button class="btn-buy-event disabledBtn">Aforo completo</button>
      </div>
    </div>
    <ng-template #divCompleteTemplate>
      <div *ngIf="event.only_tpv_sales; else divTemplate">
        <div class="container-btns-select">
          <button class="btn-buy-event disabledBtn">Venta en taquilla</button>
        </div>
      </div>
      <!-- El evento oculto no se mostrará en las páginas principales pero si tienes el enlace si que permitirá comprar -->
      <ng-template #divTemplate>
        <!-- <div *ngIf="event?.hiddenEvent else divActive">
        <div class="container-btns-select">
          <button class="btn-buy-event disabledBtn">Venta no disponible</button>
        </div>
      </div>
      <ng-template #divActive> -->
        <div
          *ngIf="(!event?.informative || !event.external || (event.external && event.external_url))">
          <div class="container-btns-select"
            *ngIf="!event.external && !pastEvent && disabledSales; else divEnabled">
            <!-- «Próximamente» a secas no dice cuándo, así que encima del
                 botón van el día en que abre la venta y el reloj. En la barra
                 de móvil el reloj se encoge a una línea (ver el SCSS). -->
            <div class="sales-soon" *ngIf="salesOpenDate">
              <p class="sales-soon-when">
                <span class="when-label">A la venta</span>
                <span class="when-date">{{ salesOpenLabel }}</span>
              </p>
              <div class="sales-soon-clock" *ngIf="countdown as cd" [class.has-days]="cd.days > 0">
                <!-- El último día la caja se cae: «00 Días» no dice nada -->
                <div class="clock-cell" *ngIf="cd.days > 0">
                  <span class="clock-box">{{ cd.dd }}<span class="clock-tag-short">d</span></span>
                  <span class="clock-tag">{{ cd.days === 1 ? 'Día' : 'Días' }}</span>
                </div>
                <div class="clock-cell">
                  <span class="clock-box">{{ cd.hh }}<span class="clock-tag-short">h</span></span>
                  <span class="clock-tag">Horas</span>
                </div>
                <div class="clock-cell">
                  <span class="clock-box">{{ cd.mm }}<span class="clock-tag-short">m</span></span>
                  <span class="clock-tag">Min</span>
                </div>
                <div class="clock-cell clock-cell-seconds">
                  <span class="clock-box">{{ cd.ss }}<span class="clock-tag-short">s</span></span>
                  <span class="clock-tag">Seg</span>
                </div>
              </div>
            </div>
            <button class="btn-buy-event disabledBtn">Próximamente</button>
          </div>
          <ng-template #divEnabled>
            <div class="container-btns-select"
              *ngIf="(!endSales && !endedEvent) && !disabledSales; else divFinal">
              <button class="btn-buy-event pointer-in"
                *ngIf="!event?.external || event?.external_url"
                (click)="openEvent(event?.external_url)"
                [class.loading]="openingMap"
                [class.btn-event-totem]="viewTotem">
                <ng-container *ngIf="!openingMap">{{ event?.external ? 'Quiero asistir' : 'Seleccionar entradas'
                  }}</ng-container>
                <ng-container *ngIf="openingMap"><i class="fa-light fa-spinner-third fa-spin"></i>Cargando
                  mapa...</ng-container></button>
              <button class="btn-buy-event btn-buy-bono pointer-in"
                [class.btn-event-totem]="viewTotem"
                *ngIf="!event?.external && enableAbono" (click)="buyAbono()">
                <!-- En la barra de móvil solo cabe «Abonos» -->
                <span class="bono-long">Comprar </span>Abonos</button>
            </div>
            <ng-template #divFinal>
              <div class="container-btns-select" *ngIf="endSales || endedEvent">
                <button class="btn-buy-event"
                  [class.btn-event-totem]="viewTotem" style="cursor: default;">
                  {{endedEvent? 'Finalizado' : 'Venta cerrada'}}</button>
              </div>
            </ng-template>
          </ng-template>
        </div>
      </ng-template>
      <!-- </ng-template> -->
    </ng-template>
  </div>
</div>